
import { Link } from 'react-router-dom';

interface FinancingBannerProps {
  context?: string;
}

export default function FinancingBanner({ context }: FinancingBannerProps) {
  return (
    <section className="py-16 px-6 bg-gradient-to-br from-emerald-50 via-white to-emerald-50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white rounded-xl border border-emerald-200 shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-5 gap-0">
            {/* Left Content */}
            <div className="md:col-span-3 p-8 md:p-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-800 rounded-lg">
                  <i className="ri-bank-card-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">
                  Flexible Financing Available
                </h3>
              </div>

              <p className="text-gray-700 leading-relaxed mb-5">
                {context
                  ? context
                  : "Don\u2019t let budget timing hold you back. We offer flexible payment options so you can get the service you need, when you need it."}
              </p>

              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-emerald-100 rounded-full shrink-0">
                    <i className="ri-check-line text-emerald-700 text-sm"></i>
                  </div>
                  <span className="text-sm text-gray-800 font-medium">
                    0% APR promotional plans available for qualified applicants
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-emerald-100 rounded-full shrink-0">
                    <i className="ri-check-line text-emerald-700 text-sm"></i>
                  </div>
                  <span className="text-sm text-gray-800 font-medium">
                    Payment terms from 6 to 24 months
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-emerald-100 rounded-full shrink-0">
                    <i className="ri-check-line text-emerald-700 text-sm"></i>
                  </div>
                  <span className="text-sm text-gray-800 font-medium">
                    Quick approval — most decisions within 24 hours
                  </span>
                </div>
              </div>

              <div className="flex flex-wrap gap-3">
                <a
                  href="tel:+17179131780"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-800 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  <i className="ri-phone-line"></i>
                  Call for Details
                </a>
                <Link
                  to="/instant-quote"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-emerald-800 font-semibold rounded-lg border-2 border-emerald-800 hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  <i className="ri-calculator-line"></i>
                  Get an Instant Quote
                </Link>
              </div>

              <p className="text-xs text-gray-500 mt-5 leading-relaxed">
                Financing subject to credit approval and qualification requirements. Contact us for complete details and current promotional offers.
              </p>
            </div>

            {/* Right Highlight */}
            <div className="md:col-span-2 bg-gradient-to-br from-emerald-800 to-emerald-900 p-8 md:p-10 flex flex-col justify-center text-white">
              <div className="text-center">
                <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-4">
                  <i className="ri-percent-line text-3xl text-emerald-300"></i>
                </div>
                <p className="text-emerald-300 text-sm font-semibold tracking-wide mb-2">
                  ASK ABOUT
                </p>
                <p className="text-4xl font-bold mb-1">0% APR</p>
                <p className="text-emerald-200 text-sm mb-6">
                  Promotional Financing
                </p>

                <div className="space-y-3 text-left">
                  <div className="flex items-center gap-3">
                    <i className="ri-time-line text-emerald-300"></i>
                    <span className="text-sm text-emerald-100">6, 12, or 24-month terms</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-shield-check-line text-emerald-300"></i>
                    <span className="text-sm text-emerald-100">No prepayment penalties</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-flashlight-line text-emerald-300"></i>
                    <span className="text-sm text-emerald-100">Fast, simple application</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
